import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    total: 0,
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getTotal(state) {
      return state.total;
    },
  },
  mutations: {
    setData(state, payload) {
      state.items = payload.items || [];
      state.total = payload.total || 0;
    },
  },
  actions: {
    async fetchAudits({ commit }, params) {
      const response = await axios.get("/v1/security_self_audits", { params });
      const { data, total } = response.data;
      commit("setData", { items: data, total: total });
      return response.data;
    },
    async deleteAudit(_, auditId) {
      const { data } = await axios.delete(`/v1/security_self_audits/${auditId}`);
      return data;
    },
    async updateAuditStatus(_, { auditId, statusName }) {
      const { data } = await axios.post(`/v1/security_self_audits/update_status/${auditId}`, {
        status_name: statusName,
      });
      return data;
    },
    async createAudit(_, payload) {
      const { data } = await axios.post("/v1/security_self_audits", payload);
      return data;
    },
    async updateAudit(_, { auditId, payload }) {
      const { data } = await axios.put(`/v1/security_self_audits/${auditId}`, payload);
      return data;
    },
  },
};
